import { render } from "./smallTable.vue?vue&type=template&id=058d0e98"
import script from "./smallTable.vue?vue&type=script&lang=js"
export * from "./smallTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__